/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

export type ListChallengesSecurity = {
  apikeyHeaderGramKey?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

/**
 * Filter by outcome.
 */
export const QueryParamOutcome = {
  Allow: "allow",
  Deny: "deny",
} as const;
/**
 * Filter by outcome.
 */
export type QueryParamOutcome = ClosedEnum<typeof QueryParamOutcome>;

export type ListChallengesRequest = {
  /**
   * Filter by outcome.
   */
  outcome?: QueryParamOutcome | undefined;
  /**
   * Filter by principal URN.
   */
  principalUrn?: string | undefined;
  /**
   * Filter by scope.
   */
  scope?: string | undefined;
  /**
   * Filter to a specific project.
   */
  projectId?: string | undefined;
  /**
   * Filter by resolution state. True = only resolved, false = only unresolved.
   */
  resolved?: boolean | undefined;
  /**
   * Fetch specific challenges by ID. When set, other filters and pagination are ignored.
   */
  ids?: Array<string> | undefined;
  /**
   * Inclusive start of the window to list challenges from. Omit for the whole history.
   */
  from?: Date | undefined;
  /**
   * Exclusive end of the window to list challenges from. Omit for the whole history.
   */
  to?: Date | undefined;
  /**
   * Maximum number of results to return.
   */
  limit?: number | undefined;
  /**
   * Number of results to skip.
   */
  offset?: number | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type ListChallengesSecurity$Outbound = {
  "apikey_header_Gram-Key"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const ListChallengesSecurity$outboundSchema: z.ZodMiniType<
  ListChallengesSecurity$Outbound,
  ListChallengesSecurity
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function listChallengesSecurityToJSON(
  listChallengesSecurity: ListChallengesSecurity,
): string {
  return JSON.stringify(
    ListChallengesSecurity$outboundSchema.parse(listChallengesSecurity),
  );
}

/** @internal */
export const QueryParamOutcome$outboundSchema: z.ZodMiniEnum<
  typeof QueryParamOutcome
> = z.enum(QueryParamOutcome);

/** @internal */
export type ListChallengesRequest$Outbound = {
  outcome?: string | undefined;
  principal_urn?: string | undefined;
  scope?: string | undefined;
  project_id?: string | undefined;
  resolved?: boolean | undefined;
  ids?: Array<string> | undefined;
  from?: string | undefined;
  to?: string | undefined;
  limit: number;
  offset: number;
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const ListChallengesRequest$outboundSchema: z.ZodMiniType<
  ListChallengesRequest$Outbound,
  ListChallengesRequest
> = z.pipe(
  z.object({
    outcome: z.optional(QueryParamOutcome$outboundSchema),
    principalUrn: z.optional(z.string()),
    scope: z.optional(z.string()),
    projectId: z.optional(z.string()),
    resolved: z.optional(z.boolean()),
    ids: z.optional(z.array(z.string())),
    from: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    to: z.optional(z.pipe(z.date(), z.transform(v => v.toISOString()))),
    limit: z._default(z.int(), 50),
    offset: z._default(z.int(), 0),
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      principalUrn: "principal_urn",
      projectId: "project_id",
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
    });
  }),
);

export function listChallengesRequestToJSON(
  listChallengesRequest: ListChallengesRequest,
): string {
  return JSON.stringify(
    ListChallengesRequest$outboundSchema.parse(listChallengesRequest),
  );
}
